import { Component, Input } from '@angular/core';
import { PineLabsTimeOut } from 'src/app/common/enums/pinelabs.enum';
import { CurrencyService } from 'src/app/util/currency.service';
import { PINE_LAB_MAX_ICON } from 'src/defaultImages.js';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.css'],
})
export class ProgressBarComponent{
    
  @Input() plAmount:number;  
  @Input() percentageElapsed:number;
  @Input() deadlineDate:any;
  currency:string='';

  images = {
    PINE_LAB_MAX_ICON: PINE_LAB_MAX_ICON,
  };
  PineLabsTimeOut = PineLabsTimeOut;
  constructor(
    private _curr: CurrencyService,
  ) {
    this.currency = this._curr.getCurrency();
  }
}
